const Centipede = () => {
  return (
    <div>
      <p>
        A bitmap game based on the 1980 Atari arcade game Centipede. The
        centipede zig zags from top to bottom and switches direction when it
        encounters a mushroom (brown). The bug blaster (purple) on the bottom
        can move left and right using the <code>j k</code> keys and can shoot
        darts (pink) when <code>x</code> is pressed.
      </p>
    </div>
  );
};

export default Centipede;
